export default function Header(){
  return(
    <div id="page-footer">
      © Copyright 2023 * DogaoPet® – Todos os direitos reservados | DOGAO PET LTDA / CNPJ: 27.302.856/0001-78
    </div>
  )
}
